import { lazy } from 'react';
import { authRoles } from 'app/auth';

const RequestsMcKesson = lazy(() => import('../Patients/McKesson/RequestsPage'));

const RequestsConfig = {
  settings: {
    layout: {
      config: {
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: true,
          options: {
            pharmacySelector: true,
          },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'requests',
      element: <RequestsMcKesson />,
    },
  ],
};

export default RequestsConfig;
